import React from "react";
import "./ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../i18n';
import { useTranslation } from 'react-i18next';

import Spin26_QUANTA from './product_cards/Spin26_QUANTA'
import Spin57_QUANTA from './product_cards/Spin57_QUANTA'

const ProductCardsQuanta = () => {
  const { t, i18n } = useTranslation();
  
  return (
    <div className="Products">
      <div class="card-list-modems">
       
        <Spin26_QUANTA />
        <Spin57_QUANTA />
        
      </div>
    </div>
  );
};
export default ProductCardsQuanta;